var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rj-tabs',{model:{value:(_vm.tabsActive),callback:function ($$v) {_vm.tabsActive=$$v},expression:"tabsActive"}},[_c('rj-tab-pane',{attrs:{"label":"待审核订单","name":"1"}},[_c('invoice-to-be-reviewed')],1),_c('rj-tab-pane',{attrs:{"label":"已审核订单"}},[_c('invoice-has-been-reviewed',{attrs:{"name":"2"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }